import Button from 'components/Button';
import Error from 'components/form/Error';
import Input from 'components/form/Inputs/Input';
import Textarea from 'components/form/Inputs/Textarea';
import Success from 'components/form/Success';
import { PageHeadContainer } from 'components/PageHead';
import Typography from 'components/Typography';
import { FC, useState } from 'react';
import styled from 'styled-components';
import privateAPI from 'utils/privateAxiosInstance';
import { PageTitle } from './mentee/mentorship/sign-chart';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 50rem;
  row-gap: 1rem;
  align-self: center;
  margin-top: 1rem;
  margin-bottom: 5rem;
  h2 {
    color: var(--gray-900);
  }
`;

const ButtonContainer = styled.div`
  margin-left: auto;
  margin-right: 0;
  margin-top: 1rem;
  button {
    min-width: 10rem;
  }
`;

const Head: FC = () => {
  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Contacter l'Institut</h1>
      </PageTitle>
    </PageHeadContainer>
  );
};

type State = {
  subject: string;
  message: string;
};
const initialState: State = {
  subject: '',
  message: '',
};
const Contact: FC = () => {
  const [state, setState] = useState<State>(initialState);
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const handleChange: React.ChangeEventHandler<
    HTMLInputElement & HTMLTextAreaElement
  > = (e) => {
    return setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    setSuccess(false);

    privateAPI
      .post('/email/contact', state)
      .then(() => {
        setState(initialState);
        setSuccess(true);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
        window.scrollTo({ top: 0 });
      });
  };
  return (
    <>
      <Head />
      <Form onSubmit={handleSubmit}>
        <Typography variant="h2" color="default">
          Formulaire de contact
        </Typography>
        {success && <Success>Le message a été envoyé.</Success>}
        {error && <Error>Une erreur est survenue.</Error>}
        <Input
          name="subject"
          label="Sujet"
          placeholder="Sujet du message"
          onChange={handleChange}
          value={state.subject}
          required
        />
        <Textarea
          name="message"
          label="Message"
          placeholder="Écrivez votre message..."
          rows={15}
          onChange={handleChange}
          value={state.message}
          required
          noEnterFireSubmit
        />
        <ButtonContainer>
          <Button color="primary" type="submit" loading={loading}>
            Envoyer
          </Button>
        </ButtonContainer>
      </Form>
    </>
  );
};

export default Contact;
